import React, { Component } from 'react';
import { connect } from 'react-redux';
import ViewCreatorProfile from './ViewCreatorProfile';
import Header from '../PostProject/Header'

class PublicCreatorProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    let userName = this.props.match.params.user_name;
    this.props.loadPublicCreatorData(userName);
    this.setState({isMouned: true})
  }

  render() {
    const { isPublic, userName, isProfileLoaded } = this.props;
    return (
      <>
        {isPublic && !userName && isProfileLoaded ?  <Header title="" /> : null}
        <ViewCreatorProfile userProfile={this.props.userProfile}/>
      </>
    )
  }
}

const mapState = (store) => {
  const projectSubmitted = store.project;
  const creatorProfile = store.creatorProfile
  const globalReducer = store.globalReducer
  return {
    projectSubmitted: projectSubmitted.project_submitted,
    isPublic: creatorProfile.public,
    userName: globalReducer.Me.Username,
    isProfileLoaded: globalReducer.Me.isProfileLoaded,
  };
};
const mapDispatch = dispatchEvent => ({
  OpenPopup: (text) => dispatchEvent({ type: 'OPEN_POPUP_SAGA', payload: { Component: text } }),
  loadPublicCreatorData: (userName) => dispatchEvent({ type: 'LOAD_CREATOR_PUBLIC', payload: {user_name:userName} }),
});
export default connect(mapState, mapDispatch)(PublicCreatorProfile);
